import { put, takeLatest } from "redux-saga/effects";
import { setMedidasSelecionadasDesabilitado } from "../state";
import { GRUPAMENTO_MEDIDAS_PERSONALIZADAS } from "../model";

export default function* toogleMedidasSelecionadasDesabilitadoSaga() {
  yield takeLatest(
    ({ type }) => type === "SELECIONAR_GRUPAMENTO_MEDIDA",
    function*({ grupamento }) {
      yield put(
        setMedidasSelecionadasDesabilitado(
          grupamento === GRUPAMENTO_MEDIDAS_PERSONALIZADAS
        )
      );
    }
  );
}
